import React from 'react';
import { CheckCircleOutline } from '@mui/icons-material';
import { Typography } from '@mui/material';

import styles from './SuccessStep.module.scss';
import messages from '../../messages.json';

const SuccessStep: React.FC = () => (
  <div className={styles.banner} role="alert">
    <CheckCircleOutline color="primary" className={styles.checkIcon} />
    <Typography variant="h4">{messages.successfullySentMsg}</Typography>
  </div>
);

export default SuccessStep;
